import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { IFilters, IPagination } from '../../../../modules/authorization/store/types';
import { IBulkInvitationsUploadResult, IInvitation } from 'src/app/modules/logged/invitations/store/types';

@Injectable({
    providedIn: 'root'
})
export class InvitationService {

    constructor(
        private apiService: ApiService
    ) { }

    public fetchAll(data: IFilters): Observable<IPagination<IInvitation>> {
        return this.apiService.get('/invitations', data);
    }

    public sendInvitations(data: any): Observable<any> {
        return this.apiService.post(`/invitations`, data);
    }

    public getDynamicLink(companyID: string): Observable<string> {
        return this.apiService.get(`/subcontractors/company/${companyID}/dynamic-link`);
    }

    public resend(id: string): Observable<boolean> {
        return this.apiService.get(`/invitations/${id}/resend`);
    }

    public resendCompaniesInvitations(id: string): Observable<boolean> {
        return this.apiService.get(`/invitations/companies/${id}/resend`);
    }

    public remove(id: string): Observable<boolean> {
        return this.apiService.delete(`/invitations/${id}`);
    }

    public bulkAction(action: string, ids: string[], data?: any): Observable<any> {
        return this.apiService.post(`/invitations/bulk/${action}`, { ids, ...data });
    }

    public bulkInvitationsUpload(companyId: string, file: File): Observable<IBulkInvitationsUploadResult> {
        const formData = new FormData();
        formData.append('subcontractors', (file || ''));
        formData.append('companyID', companyId);
        return this.apiService.post(`/invitations/import`, formData);
    }

}
